import { SYSTEM_MODULES } from '@/src/utils/rolesConst';
import { formatUTCDate } from '../../../../../utils/formatUtils';
import {
  SCBillingDraft,
  SCVendorSummary,
} from '../../../../Interfaces/Accounting/Subcontracts.interfaces';
import { ITEMS_STATES } from '../SCFilters';

export const getSCReportTypeName = (id: string) => {
  const report = SYSTEM_MODULES['accounting']['subcontracts'].find(
    (report) => report.value === id
  );

  return report?.label;
};

export const getSubcontractorName = (
  selectSubcontractor: string,
  subcontractorList: SCVendorSummary[]
) => {
  const subInfo = subcontractorList?.find(
    (sub) => sub.Vendor === selectSubcontractor
  );

  return subInfo?.Name;
};

export const getSubmittedDraft = (
  seledtedDraft: string,
  data: SCBillingDraft[]
) => {
  const draft = data?.find((draft) => draft.id === seledtedDraft);

  return `${formatUTCDate(draft?.updatedAt ?? '')} - ${draft?.userName}`;
};

export const getBillItemStatusLabel = (value: string) => {
  const itemState = ITEMS_STATES.find((state) => state.value === value);

  return itemState?.label;
};
